module.exports = __webpack_public_path__ + "img/icon-uploader.117f9dfa.png";